import { Box } from "@mui/material";

import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { Seo } from "../components/Seo";
import { AboutSection } from "../components/sections/AboutSection";
import { ContactSection } from "../components/sections/ContactSection";
import { GallerySection } from "../components/sections/GallerySection";
import { HeroSection } from "../components/sections/HeroSection";
import { ProcessSection } from "../components/sections/ProcessSection";
import { ServicesSection } from "../components/sections/ServicesSection";
import { TestimonialsSection } from "../components/sections/TestimonialsSection";

export function LandingPage() {
  return (
    <Box>
      <Seo />
      <Header />
      <main>
        <HeroSection />
        <ServicesSection variant="pearl" />
        <AboutSection variant="cream" />
        <GallerySection variant="pearl" />
        <ProcessSection variant="cream" />
        <TestimonialsSection variant="blush" />
        <ContactSection variant="gold" />
      </main>
      <Footer />
    </Box>
  );
}
